<template>
  <b-tabs
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
    v-model="activeTab"
  >

    <!-- general tab -->
    <!-- <b-tab active>

      <template #title>
        <feather-icon
          icon="UserIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">General</span>
      </template>

      <account-setting-general
        v-if="options"
        :general-data="options"
        @updateProfile="updateProfile"
      />
    </b-tab> -->
  
    <!-- change password tab -->
    <b-tab>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="LockIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Alterar Senha</span>
      </template>

      <account-setting-password />
    </b-tab>
    <!--/ change password tab -->

    <!-- info -->
    <!-- <b-tab>
      <template #title>
        <feather-icon
          icon="InfoIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Information</span>
      </template>

      <account-setting-information
        v-if="options.info"
        v-model="options.info"
        @updateProfile="updateProfile"
      />
    </b-tab> -->

    <!-- social links -->
    <!-- <b-tab>

      <template #title>
        <feather-icon
          icon="LinkIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Social</span>
      </template>

      <account-setting-social
        v-if="options.social_links"
        v-model="options.social_links"
        @updateProfile="updateProfile"
      />
    </b-tab> -->

    <!-- notification -->
    <!-- <b-tab>

      <template #title>
        <feather-icon
          icon="BellIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Notifications</span>
      </template>

      <account-setting-notification
        v-if="options.notifications"
        v-model="options.notifications"
        @updateProfile="updateProfile"
      />
    </b-tab> -->
  </b-tabs>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import AccountSettingGeneral from './AccountSettingGeneral.vue'
import AccountSettingPassword from './AccountSettingPassword.vue'
import AccountSettingInformation from './AccountSettingInformation.vue'
import AccountSettingSocial from './AccountSettingSocial.vue'
import AccountSettingNotification from './AccountSettingNotification.vue'

export default {
  components: {
    BTabs,
    BTab,
    AccountSettingGeneral,
    AccountSettingPassword,
    AccountSettingInformation,
    AccountSettingSocial,
    AccountSettingNotification,
  },
  data() {
    return {
      options: {},
      activeTab: 0,
    }
  },
  created() {
    this.getProfileDB()
    this.setActiveTabFromQuery()
  },
  mounted() {
    this.getProfileDB()
  },
  watch: {
    '$route.query.tab': {
      handler() {
        this.setActiveTabFromQuery()
      },
    },
  },
  methods: {
    setActiveTabFromQuery() {
      this.activeTab = this.$route.query.tab === 'password' ? 1 : 0
    },

    async getProfileDB() {
      await this.$http.get('/profile').then(res => {
        this.options = res.data
      })
    },
    async updateProfile() {
      await this.$api.put('/profile', this.options)
        .then(() => {
          this.getProfileDB()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Atualizado!',
              icon: 'CoffeeIcon',
              variant: 'success',
              text: 'Profile atualizado com sucesso!',
            },
          })
        })
    },
  },
}
</script>
